// The sensors row — pinned directly under the common-devices strip.
//
// WHY IT IS ITS OWN ROW, ABOVE THE GRID. A sensor is not a control, and the
// device grid is a grid of controls. Left among them, a door sensor is a card
// that looks tappable, opens a screen with nothing on it, and buries the one
// thing it does have to say — its state — behind a tap. Up here the state is
// the card, and it is visible without touching anything.
//
// Same two-container rule as CommonDevicesStrip: this owns a horizontal scroll,
// the grid below owns the vertical one, and `flexShrink: 0` stops a long device
// list from squeezing the row to nothing.
//
// Renders NOTHING when there are no sensors — unlike the common strip, which
// says "No Common Devices Found" because its absence is worth reporting. Most
// rooms have no sensor, and an empty band in every one of them is noise.

import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import SensorCard from './SensorCard';

export default function SensorStrip({ devices, onOpen, onToggleFavourite }) {
  const theme = useTheme();
  const c = theme.sli;

  if (!devices || devices.length === 0) return null;

  const vw = typeof window !== 'undefined' ? window.innerWidth : 400;
  const cardSize = Math.min(200, Math.max(110, vw * 0.3));

  return (
    <Box sx={{ flexShrink: 0 }}>
      <Typography
        sx={{
          color: c.text, opacity: 0.75, fontSize: 12, fontWeight: 700,
          letterSpacing: 0.6, px: 2, pt: 0.5,
        }}
      >
        SENSORS
      </Typography>
      {/* data-hscroll: a real horizontal scroller, so the tab-swipe handler
          leaves gestures that start in here alone (see useSwipeNav). */}
      <Box
        data-hscroll
        sx={{
          display: 'flex', overflowX: 'auto', px: 1, py: 1, gap: 2,
        }}
      >
        {devices.map((d) => (
          <Box key={d.UniqueNumber} sx={{ width: cardSize, height: cardSize, flexShrink: 0 }}>
            <SensorCard
              device={d}
              onOpen={onOpen}
              onToggleFavourite={onToggleFavourite}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
